import { Dropdown } from '@cmsgov/design-system'
import React, { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { getErrorMessageController } from 'utils/react-hook-form'

type MyDropdownProps = {
  name: string
  className?: string
  label: string
  labelClassName?: string
  fieldClassName?: string
  options: {
    label: React.ReactNode
    value: string
  }[]
} & React.ComponentProps<typeof Dropdown> & Omit<Parameters<typeof Controller>[0], 'render' | 'control'>

/**
 * CMS Design System dropdown wrapped with react hook form
 */
export const MyDropdown: FC<MyDropdownProps> = ({ rules, name, label, defaultValue, ...props }) => {
  const { control } = useFormContext()

  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => (
        <Dropdown
          errorMessage={getErrorMessageController(fieldState)}
          errorPlacement='bottom'
          label={label}
          // TODO: Fix this
          inputRef={field.ref as any}
          {...field}
          {...props}
        />
      )}
    />
  )
}
